import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useCallback } from 'react';
import { propFunc, propShape } from '../../../../../helpers/custom-prop-types';
import { validateCaution } from '../../../../../validate/solution';
import FaqsFields from '../../../../Ui/Professional/Solution/Fields/Custom/FaqsFields';
import SolutionFieldArray from '../../../../Ui/Professional/Solution/Fields/SolutionFieldArray';
import SolutionTextArea from '../../../../Ui/Professional/Solution/Fields/SolutionTextArea';
import NextNav from '../../../../Ui/Professional/Solution/Parts/NextNav';
import PrevNav from '../../../../Ui/Professional/Solution/Parts/PrevNav';
const FormSolutionStep4 = (props) => {
    const { formFields, goBackStep, onClickNext, style } = props;
    const onClick = useCallback((step) => {
        const names = ['caution'];
        const faqs = _.get(formFields, 'values.faq') || [];
        for (let i = 0; i < faqs.length; i += 1) {
            names.push(`faq.${i}.question`, `faq.${i}.answer`);
        }
        onClickNext(step, names);
    }, [formFields, onClickNext]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'l-container-9', style: style }, { children: [_jsx(SolutionFieldArray, { component: FaqsFields, label: 'よくある質問', name: 'faq' }), _jsx(SolutionTextArea, { label: '注意事項（100字程度）', name: 'caution', placeholder: '実施する上での注意事項を記入してください', validate: validateCaution })] })), _jsx("div", Object.assign({ className: 'l-container-9', style: style }, { children: _jsxs("div", Object.assign({ className: 'contents-footer-nav step-nav', style: style }, { children: [_jsx(PrevNav, { goBackStep: goBackStep, step: 4 }), _jsx(NextNav, { disabled: false, goNextStep: onClick, step: 4, text: '入力内容を確認する' })] })) }))] }));
};
FormSolutionStep4.propTypes = {
    formFields: propShape().isRequired,
    goBackStep: propFunc().isRequired,
    onClickNext: propFunc().isRequired,
    style: propShape().isRequired,
};
export default FormSolutionStep4;
